import axiosInstance from "./AxiosInstance";
const documentUrl = "api/document";
// user
export function getDocumentListApi(page, page_size, query, status) {
  const params = new URLSearchParams({
    page,
    page_size,
    query,
    status
  });
  return axiosInstance.get(`${documentUrl}?${params.toString()}`);
}

export function getDocumentApi(id) {
  return axiosInstance.get(`${documentUrl}/${id}`);
}

export function createDocumentApi(data) {
  return axiosInstance.post(documentUrl, data);
}

export function editDocumentApi(data) {
  return axiosInstance.put(documentUrl, data);
}

export function updateDocumentApi(data) {
  return axiosInstance.put(documentUrl, data);
}

//document version

export function getDocumenrVersionApi(document_id, page, page_size, filter) {
  const params = new URLSearchParams({
    page,
    page_size,
    ...filter,
  });
  return axiosInstance.get(`api/document_version/${document_id}?${params.toString()}`);
}

export function createDocumenrVersionApi(document_id, data) {
  return axiosInstance.post(`api/document_version/${document_id}`, data);
}

export function updateDocumenrVersionApi(document_id, data) {
  return axiosInstance.put(`api/document_version/${document_id}`, data);
}

export function updateDocumenrVersionStatusApi(document_id, data) {
  return axiosInstance.patch(`api/document_version/${document_id}`, data);
}

export function getDocumentSheetListApi(id) {
  return axiosInstance.get(`api/sheet_document/${id}`);
}
export function getDocumentSheetReportListApi(id) {
  return axiosInstance.get(`api/sheet_document_report/${id}`);
}

//measurment sheet

export function getMeasurmentSheetListApi(page, page_size, query,status) {
  const params = new URLSearchParams({
    page,
    page_size,
    query,
    status
  });
  return axiosInstance.get(`api/measurement_sheet?${params.toString()}`);
}

export function getMeasurmentSheetApi(tesheet_id) {
    return axiosInstance.get(`api/measurement_sheet/${tesheet_id}`);
}

export function createMeasurmentSheetApi(data) {
    return axiosInstance.post(`api/measurement_sheet`, data);
}

export function updateMeasurmentSheetApi(tesheet_id, data) {
    return axiosInstance.put(`api/measurement_sheet/${tesheet_id}`, data);
}

export function updateMeasurmentSheetStatusApi(tesheet_id, data) {
  return axiosInstance.patch(`api/measurement_sheet/${tesheet_id}`, data);
}

//Circular

export function getCircularListApi(id) {
  return axiosInstance.get(`api/sheet_circular/${id}`);
}

export function getCircularApi(circular_id) {
  return axiosInstance.get(`api/circular/${circular_id}`);
}

export function createCircularApi(data) {
  return axiosInstance.post(`api/circular`, data);
}

export function updateCircularApi(circular_id, data) {
  return axiosInstance.put(`api/circular/${circular_id}`, data);
}

export function updateCircularStatusApi(circular_id, data) {
  return axiosInstance.patch(`api/circular/${circular_id}`, data);
}

//report

export function createTEReport(data) {
  return axiosInstance.post("api/te_report", data);
}

export function getTEReportList(id) {
  return axiosInstance.get(`api/te_report/${id}`);
}

export function getDocument() {
  return axiosInstance.get("api/search_document");
}

export function getDivision() {
  return axiosInstance.get("api/search_division");
}

export function getParameter() {
  return axiosInstance.get("api/search_measurement_parameter");
}

export function getSheet() {
  return axiosInstance.get("api/search_measurement_sheet");
}

export function getUser() {
  return axiosInstance.get("api/search_user");
}



// export function updateMeasurmentSheetStatusApi(document_id, data) {
//     return axiosInstance.patch(`api/measurment_sheet/${document_id}`, data);
// }

// gloabl search api

export function searchDocumentApi(query) {
  return axiosInstance.get(`api/global_search_document?query=${query}`);
}
